import { render, staticRenderFns } from "./DurationEntry.vue?vue&type=template&id=863283c2&"
import script from "./DurationEntry.vue?vue&type=script&lang=js&"
export * from "./DurationEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports